import module from 'fan/proyectos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class FanProyectosAgregarComponent {
  agregando = false
  catalogos = {}
  data = {
    nombre: '',
    op_id_empresa: undefined,
    sa_id_empresa: '',
    serie_timbrado: '',
    id_cliente: undefined,
    id_estado: undefined,
  }

  constructor ($q, FanProyectosCatalogosClientes, FanProyectosCatalogosEstados, FanProyectosCatalogosEmpresas) {
    this.$q = $q
    this.FanProyectosCatalogosClientesService = FanProyectosCatalogosClientes
    this.FanProyectosCatalogosEstadosService = FanProyectosCatalogosEstados
    this.FanProyectosCatalogosEmpresasService = FanProyectosCatalogosEmpresas
  }

  $onInit () {
    this.$q.all([
      this.FanProyectosCatalogosClientesService.get()
        .then((response) => (this.catalogos.clientes = orderBy(response.data, ['Nombre']))),
      this.FanProyectosCatalogosEstadosService.get()
        .then((response) => (this.catalogos.estados = orderBy(response.data, ['descripcion']))),
      this.FanProyectosCatalogosEmpresasService.get()
        .then((response) => (this.catalogos.empresas = orderBy(response.data, ['nombre']))),
    ])
  }
}

module.component('fanProyectosAgregar', {
  controller: FanProyectosAgregarComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fan/proyectos/components/agregar/component.js